module.exports = __webpack_public_path__ + "img/blockS2-cardT2.8319cb4f.svg";